/**
 * Frontend role constants — mirror backend UserRoles.cs values.
 * Keep this file in sync with src/Core/Beetegre.Domain/Entities/UserRoles.cs.
 */
export const USER_ROLES = {
  SUPER_ADMIN: 'SuperAdmin',
  TENANT_ADMIN: 'TenantAdmin',
  TENANT_MEMBER: 'TenantMember',
} as const;

export type UserRole = typeof USER_ROLES[keyof typeof USER_ROLES];
